import { render, staticRenderFns } from "./dialog-insertrelationoutbox.vue?vue&type=template&id=51a6c08c&"
import script from "./dialog-insertrelationoutbox.vue?vue&type=script&lang=js&"
export * from "./dialog-insertrelationoutbox.vue?vue&type=script&lang=js&"
import style0 from "./dialog-insertrelationoutbox.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports